export default {
  fonts: {
    serif: "Georgia, serif",
    sans: "'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    condensed:
      "'Roboto Condensed', 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
  transitions: {
    hover: "100ms ease-out",
  },
  snippets: {
    paddingLikeText: `
      padding-left: 15px;
      padding-right: 15px;
      @media screen and (min-width: 375px) {
        padding-left: 7%;
        padding-right: 7%;
      }
      @media screen and (min-width: 960px) {
        padding-left: 60px;
        padding-right: 60px;
      }
    `,
    resetButton: `
      appearance: none;
      cursor: pointer;
      border: none;
      margin: 0;
      padding: 0;
      width: auto;
      overflow: visible;
      background: transparent !important;
      color: inherit;
      font: inherit;
      line-height: normal;
      font-smoothing: inherit;
      box-shadow: none !important;
      text-align: left;
      &:hover {
        background: none;
      }
    `,
    bulletedAfter: (number) => `
      &:after {
        content: "${number}";
        position: absolute;
        top: 6px;
        left: 6px;
        background: #222;
        color: white;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        height: 20px;
        width: 20px;
        font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 12px;
        -moz-osx-font-smoothing: unset;
      }
    `,
  },
  breakpoints: {
    xs: {
      down: "@media screen and (max-width: 479px)",
      up: "@media screen and (min-width: 480px)",
    },
    sm: {
      down: "@media screen and (max-width: 767px)",
      up: "@media screen and (min-width: 768px)",
    },
    md: {
      down: "@media screen and (max-width: 991px)",
      up: "@media screen and (min-width: 992px)",
    },
    lg: {
      down: "@media screen and (max-width: 1199px)",
      up: "@media screen and (min-width: 1200px)",
    },
    xl: {
      down: "@media screen and (max-width: 1599px)",
      up: "@media screen and (min-width: 1600px)",
    },
    vertical: {
      xs: {
        down: "@media screen and (max-height: 479px)",
        up: "@media screen and (min-height: 480px)",
      },
      sm: {
        down: "@media screen and (max-height: 767px)",
        up: "@media screen and (min-height: 768px)",
      },
      md: {
        down: "@media screen and (max-height: 991px)",
        up: "@media screen and (min-height: 992px)",
      },
      lg: {
        down: "@media screen and (max-height: 1199px)",
        up: "@media screen and (min-height: 1200px)",
      },
      xl: {
        down: "@media screen and (max-height: 1599px)",
        up: "@media screen and (min-height: 1600px)",
      },
    },
    combined: {
      xs: {
        down: "@media screen and (max-width: 479px) and (max-height: 479px)",
        up: "@media screen and (min-width: 480px) and (min-height: 480px)",
      },
      sm: {
        down: "@media screen and (max-width: 767px) and (max-height: 767px)",
        up: "@media screen and (min-width: 768px) and (min-height: 768px)",
      },
      md: {
        down: "@media screen and (max-width: 991px) and (max-height: 991px)",
        up: "@media screen and (min-width: 992px) and (min-height: 992px)",
      },
      lg: {
        down: "@media screen and (max-width: 1199px) and (max-height: 1199px)",
        up: "@media screen and (min-width: 1200px) and (min-height: 1200px)",
      },
      xl: {
        down: "@media screen and (max-width: 1599px) and (max-height: 1599px)",
        up: "@media screen and (min-width: 1600px) and (min-height: 1600px)",
      },
    },
  },
  colors: {
    democratic: "#2D67AB",
    democraticReduced: "rgba(45, 103, 171, 0.2)",
    republican: "#D14F4F",
    republicanReduced: "rgba(209, 79, 79, 0.2)",

    black: "#222",
    grey20: "#424242",
    grey30: "#5a5a5a", // grey intro text
    grey40: "#777", // button border-bottom next to input
    grey50: "#9a9a9a", //  light text
    grey60: "#A3A3A3", // button border-bottom
    grey70: "#ccc", // input / button border
    grey80: "#ddd", // seperator lines
    grey85: "#eee",
    grey90: "#F9F9F9", // bg / button hover

    red20: "#9E1B1B",
    red30: "#B32424",
    red35: "#BF3434",
    red40: "#CC3B3B",
    red: "#D14F4F",
    red55: "#DB6060",
    red60: "#F26D6D",
    red65: "#FF8282",
    red75: "#FFA8A8",
    red85: "#FFCFCF",

    blue20: "#154B8A",
    blue30: "#1E599E",
    blue35: "#2D67AB",
    blue40: "#3872B5",
    blue: "#4C80BC",
    blue55: "#5A8CC7",
    blue60: "#6B9EDB",
    blue65: "#83B0E5",
    blue75: "#A4C8F1",
    blue85: "#C9E2FF",

    green20: "#10612C",
    green30: "#157035",
    green35: "#268045",
    green40: "#278F4B",
    green: "#319E59",
    green55: "#3EB068",
    green60: "#5AB87B",
    green65: "#7CBF93",
    green75: "#9CD9B1",
    green85: "#BFF2D1",

    errorRed: "#FF3232",
    bmGreen: "#4A7E3E",

    twitter: "#5eaade",
    facebook: "#4864bb",
    whatsapp: "#42aa42",

    marker: "#fffdc0",

    accent1: "#D14F4F",
    accent2: "#4C80BC",

    links: "#4C80BC",
  },
  parties: {
    union: "#373737",
    unionMax: "#2d2d2d",
    unionMin: "#d8d8d8",
    spd: "#DB4240",
    spdMax: "#bf252c",
    spdMin: "#ffe3e1",
    linke: "#96276E",
    linkeMax: "#7d0358",
    linkeMin: "#fad5ed",
    gruene: "#4BA345",
    grueneMax: "#308b2f",
    grueneMin: "#d6f3d4",
    fdp: "#F6BB00",
    fdpMax: "#daa300",
    fdpMin: "#fff7ce",
    afd: "#34A3D2",
    afdMax: "#008bb9",
    afdMin: "#cff6ff",
    sonstige: "#888888",
    sonstigeMax: "#737373",
    sonstigeMin: "#f3f3f3",
    other: "#129B93",
    otherMax: "#00837c",
    otherMin: "#caf7f5",
    piraten: "#E9872A",
    piratenMax: "#cd700c",
    piratenMin: "#fbebdb",
    nichtwaehler: "#6C7D97",
    nichtwaehlerMax: "#566780",
    nichtwaehlerMin: "#e4e8ec",
  },
};
